import { render, staticRenderFns } from "./mycollect.vue?vue&type=template&id=6ba6feef&scoped=true&"
import script from "./mycollect.vue?vue&type=script&lang=ts&"
export * from "./mycollect.vue?vue&type=script&lang=ts&"
import style0 from "./mycollect.vue?vue&type=style&index=0&id=6ba6feef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba6feef",
  null
  
)

export default component.exports